<template>
  <div class="box12"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box12 {
  position: relative;
  width: 100%;
  height: 200px;
  background: url("../../../assets/coursePage/media/box12/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;

  box-sizing: border-box;
}
</style>
